import { render, staticRenderFns } from "./CreateHeadForm.vue?vue&type=template&id=16618000&scoped=true"
import script from "./CreateHeadForm.vue?vue&type=script&lang=js"
export * from "./CreateHeadForm.vue?vue&type=script&lang=js"
import style0 from "./CreateHeadForm.vue?vue&type=style&index=0&id=16618000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16618000",
  null
  
)

export default component.exports